import { render } from "./EnergyTransitionReduceCarbon.vue?vue&type=template&id=7dbf5212&ts=true"
import script from "./EnergyTransitionReduceCarbon.vue?vue&type=script&lang=ts"
export * from "./EnergyTransitionReduceCarbon.vue?vue&type=script&lang=ts"

import "./EnergyTransitionReduceCarbon.vue?vue&type=style&index=0&id=7dbf5212&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__